import { HttpInterceptorFn } from '@angular/common/http'

const SKIPPED_PATH = '/security/oauth/token'

export const contentTypeInterceptor: HttpInterceptorFn = (req, next) => {
	if (req.url.includes(SKIPPED_PATH)) return next(req)

	return next(
		req.clone({
			headers: req.headers.set('Content-Type', 'application/json'),
		})
	)
}
